import React from 'react';

import CustomModal from '../../components/CustomModal';
import { CrossIcon, WarningIcon } from '../../assets/icons';
import Button from '../../components/Button';
import useModalState from '../../context/modal/useModalState';

const WarningModal: React.FC = () => {
    const { modalData, closeModal } = useModalState();
    const onClose = () => closeModal('warningModal');

    return (
        <CustomModal
            modalName='warningModal'
            className='status-modal warning-modal'
            overlayClassName='status-modal'
        >
            <div className='content'>
                <Button onClick={onClose}>
                    <CrossIcon />
                </Button>
                <div className='icon-container'>
                    <WarningIcon />
                </div>
                <div className='status'>Warning!</div>
                <div
                    className='message'
                    dangerouslySetInnerHTML={{ __html: modalData.message }}
                />
            </div>
        </CustomModal>
    );
};

export default WarningModal;
